import React, { useEffect, useState } from "react";
import styles from "../../styles/dashboard.module.scss";
import { authSVC } from "../../services";
import moment from "moment";
import { useB2BContext } from "../../context/ContextB2B";
import BarChartOverview from "./BarChart";
import DepartmentByProgressBar from "./DepartmentByProgressBar";
import PieChartData from "./PieChart";
import OverallResult from "./OverallResult";
import { useNavigate, useLocation } from "react-router-dom";

import IndexBarChartCustom from "./StaticTwoMonthChartCustom";
import { AppModal } from "../../components/common";

const levelsData = [
  {
    level: 0,
    color: "#FFDAEE",
  },
  {
    level: 1,
    color: "#FCD6E9",
  },
  {
    level: 2,
    color: "#F9BCDC",
  },
  {
    level: 3,
    color: "#F69FCC",
  },
  {
    level: 4,
    color: "#F168B1",
  },
  {
    level: 5,
    color: "#F04BA1",
  },
  {
    level: 6,
    color: "#EC3192",
  },
  {
    level: 7,
    color: "#EB1481",
  },
  {
    level: 8,
    color: "#CE1273",
  },
];
function OverviewCustom() {
  const [overallLevel, setoverallLevel] = useState<any>(null);
  const { getUserByID, setUserByID } = useB2BContext();
  const [isLoading, setIsLoding] = useState(true);
  const [isPaymentApproved, setIsPaymentApproved] = useState(false);

  const handlePaymentApproved = () => {
    setIsPaymentApproved(true);
  };

  const handleCancelPaymentApproved = () => {
    setIsPaymentApproved(false);

    // window.location.reload();
  };

  useEffect(() => {
    const month: any = moment().format("M");
    const year: any = moment().format("yyyy");
    // setIsLoding(true);
    if (getUserByID) {
      authSVC
        .getoverAllViewLevels(getUserByID?.company, month, year)
        .then((res) => {
          setoverallLevel(res?.data?.data[0]);
          console.log(res?.data?.data[0], "res?.data?.data[0]");
          setIsLoding(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  useEffect(() => {
    console.log(getUserByID, "find user type ");
    if (
      getUserByID?.is_payment === true &&
      getUserByID?.first_welcome_message === false
    ) {
      setIsPaymentApproved(true);
      authSVC
        .setFirstWelcomeMessage({ user_id: getUserByID?._id })
        .then((res) => {
          console.log("is first true");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  return (
    <div className={styles.wellness_report_main_wrapper}>
      {!isLoading ? (
        <>
          <p className={styles.info_text}>
            <img src="/img/Group19216.svg" alt="" /> A lower index value
            indicates a less confused mental state.
          </p>
          <div className={styles.col_2_div}>
            {/* Left Container */}
            <div className={styles.data_container}>
              <OverallResult overallLevel={overallLevel} />
              {getUserByID.is_mock_account === true ? (
                <div className={styles.recommendations_wrapper}>
                  <div className={styles.title}>
                    <h2>Recommendations</h2>
                    <p>Enhanced Wellness, Happiness, and Engagement</p>
                  </div>
                  <div className={styles.recommendations_text}>
                    <h3>1. Webinars for Wellness Awareness</h3>
                    <p>
                      Curate webinars hosted by experts to address different
                      aspects of team well-being. Suggested themes include:
                    </p>
                    <ul>
                      <li>
                        Mindfulness Practices: Learn techniques to stay present
                        and manage stress.
                      </li>
                      <li>
                        Trauma Healing Sessions: Tools for overcoming past
                        experiences that impact performance.
                      </li>
                      <li>
                        Work-Life Integration: Strategies for maintaining
                        balance in a hybrid work culture.
                      </li>
                    </ul>
                  </div>
                  <div className={styles.recommendations_text}>
                    <h3>2. Engagement Activities</h3>
                    <p>
                      Organize short, impactful 5-minute activities led by team
                      leaders. These can include:
                    </p>
                    <ul>
                      <li>
                        Icebreaker games for virtual or in-person meetings.
                      </li>
                      <li>Gratitude rounds to foster positivity.</li>
                      <li>
                        Quick wellness challenges such as step counts or
                        hydration goals.
                      </li>
                    </ul>
                  </div>
                  <div className={styles.recommendations_text}>
                    <h3>3. Customized Resource Packs for Leaders</h3>
                    <p>
                      Develop leadership toolkits focusing on mental health
                      awareness and engagement strategies. This will equip
                      managers with actionable insights and tactics for
                      maintaining team motivation.
                    </p>
                  </div>
                  <div className={styles.recommendations_text}>
                    <h3>4. Ongoing Analytics Support</h3>
                    <p>
                      Offer HR teams access to advanced SOULSARA insights,
                      allowing them to track progress and implement data-driven
                      interventions tailored to the evolving needs of their
                      workforce.
                    </p>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            {/* Right Container */}
            <div className={styles.data_container}>
              <BarChartOverview />
              <DepartmentByProgressBar />
              {/* <IndexBarChart /> */}
              <IndexBarChartCustom />

              <PieChartData levelsData={levelsData} />
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "400px",
          }}
        >
          <div className="spinner"></div>
        </div>
      )}

      <AppModal
        open={isPaymentApproved}
        onOk={handlePaymentApproved}
        onCancel={handleCancelPaymentApproved}
        className="paymat_status_modal"
      >
        <div className="payment_status_wrapper">
          <img src="/img/Group19356.png" alt="" width="100%" height="240px" />
          <div className="thank_you_content">
            <h2>Welcome to SOULSARA, Your Wellness Community</h2>
            <p>
              Thank you for choosing us to support your team’s health,
              happiness, and productivity.
            </p>
            <a href="/departments" className="start_btn">
              start adding your team now! 🚀
            </a>
            <p className="help">
              Need help? We are here for you!{" "}
              <a
                href="https://www.soulsara.world/contact-us"
                target="_blank"
                rel="noreferrer"
              >
                contact us
              </a>
            </p>
          </div>
        </div>
      </AppModal>
    </div>
  );
}

export default OverviewCustom;